import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import { isApiResponse, isReportAccess, date_range_config,reactSelectStyles,user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';


const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var timestamp  = new Date().getTime();
var date_config = date_range_config('0', '0', '2020-02-01','0');
function MergeGridCells(tableName) {
    var dimension_cells = new Array();
    var dimension_col = null;
    var columnCount = $("#"+tableName+" tr:first th").length;
    //alert(columnCount)
    for (dimension_col = 0; dimension_col <= 1; dimension_col++) {
        // first_instance holds the first instance of identical td
        var first_instance = null;
        var rowspan = 1;
        // iterate through rows
        $("#"+tableName).find('tr').each(function () {
            //console.log("sssssss");

            // find the td of the correct column (determined by the dimension_col set above)
            var dimension_td = $(this).find('td:nth-child(' + dimension_col + ')');



            if (first_instance === null) {
                // must be the first row
                first_instance = dimension_td;
            } else if (dimension_td.text() === first_instance.text()) {
                // the current td is identical to the previous
                // remove the current td
                // dimension_td.remove();
                dimension_td.attr('hidden', true);
                ++rowspan;
                // increment the rowspan attribute of the first instance
                first_instance.attr('rowspan', rowspan);


            } else {
                //first_instance.attr('rowspan', rowspan);
                // this cell is different from the last
                //alert(columnCount);
                var s = 0;
                for (s = 0; s <= columnCount; s++) {
                     console.log("sssssss", s)
                     $(this).find('td:nth-child(' +s+ ')').attr('class', "prod-sep");
                }
//                 var dimension_col22 = 3;
//                 var dimension_td22 = $(this).find('td:nth-child(' + dimension_col22 + ')');
//                 dimension_td22.attr('class', "kkkkkkkkkkkkkkkkkkkkk");
                first_instance = dimension_td;
                rowspan = 1;
            }
        });
    }
}
class ProductErrorReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            tableHeaders:[],
            tableBody:[],
            months:"",
            monthValue:null,
            monthsLists:[],
            is_export: false,
            model_visible : false,
            file_url: '',
            rfile: '',
            is_record: true,
            tableHeadersDetails:[],
            tableBodyDetails:[],
            selected_tab:"standard",
            errorTypeLists:[{value:'User', label: 'User Error'},{value:'Non User', label: 'Non User Error'}],
            errorTypeValue:null,
            errorType:"",
        }

    }

    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'product_error_report');

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
    }
    componentDidUpdate() {

    }

    componentDidMount() {
        this.product_err_month_filters();
        //this.get_filtered_error_report(this.state.yestSend,this.state.todSend);
        //alert(this.state.selected_tab)
        setTimeout(function(){
        if(this.state.selected_tab==='standard') {
            this.get_filtered_error_report("", "");
        }
        if(this.state.selected_tab==='details') {
            this.get_filtered_error_report_details("", "");
        }
    }.bind(this), 200);
        //this.get_filtered_error_report_details(this.state.yestSend,this.state.todSend);
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'product_error_report','sparcs')
    }
    product_err_month_filters(){
        axios.get(config.get('API_URL')+'/filters/product_err_month_filters/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var moList = []
                response.data.map((month, index) => {
                    moList.push({value: month.monthyear, label: month.monthyear})
                });
                this.setState({
                    monthsLists:moList,
                })
                //console.log(moList)
            }

        });
    }
    changeMonth(optionSelected) {
        let value='';
        let mArray = [];
        if(optionSelected.length<1){
            value = null;
            mArray = '';
        }
        else{
            optionSelected.map((months, i) => {
                mArray.push(months.value)
                var index = this.state.monthsLists.findIndex(obj => obj.value == months.value);
                this.state.monthsLists.move(index, 0).join(',');

            });

        }
        this.setState({
            months: mArray,
            monthValue:optionSelected,
            isChange: true,
        });
    }
    apply_filter(start_date, end_date, type){
      setTimeout(function(){
        if(type==='standard') {
            this.get_filtered_error_report("", "");
        }
        if(type==='details') {
            this.get_filtered_error_report_details("", "");
        }
    }.bind(this), 200);

    }
    get_filtered_error_report(start_date, end_date) {
        if ($.fn.DataTable.isDataTable('#ErrorTable')) {
            $('#ErrorTable').DataTable().destroy();
        }
        if(Array.isArray(this.state.months) && this.state.months.length) {
            if(this.state.months.length>6){
                alert("Please select less than 7 month at a time");
                return false;
            }
        }
        var that = this;
        this.setState({
            is_export: false,
            is_record: true,
            selected_tab: "standard"
        })
        isApiResponse(false);

        axios.post(config.get('API_URL') + '/InternalReport/product_error_report', {
            months:this.state.months
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            isApiResponse(true);


        let tableHeaders = [];
        var no_of_rows = response.data.length;
        if(response.data.length>0) {
            const keys = Object.keys(response.data[0]);
            keys.forEach(function (k) {
                //console.log(k)
                 tableHeaders.push(k);
            });


       
        this.setState({
            tableHeaders:tableHeaders,
            tableBody:response.data,
           
        })
        setTimeout(function(){
            let total = '';
            let pageTotal = '';
            $('#ErrorTable').DataTable( {
                searching: true,
                bInfo : false,
                paging: false,
                "bSort": false,
                "responsive": true,
                "scrollX": false,
//                 "pageLength": 20,
//                 "lengthMenu": [[20, 50, 100, -1], [20, 50, 100, "All"]],

                
            } );
            MergeGridCells("ErrorTable");
            that.setState({
                loading:false,
                is_export: true,
                isChange: false
            })
        }, 200);
        }
        else{
            this.setState({
                is_record: false
            })
        }
    });
    }
    get_filtered_error_report_details(start_date, end_date) {

        if(Array.isArray(this.state.months) && this.state.months.length) {
            if(this.state.months.length>6){
                alert("Please select less than 7 month at a time");
                return false;
            }
        }
        var that = this;
        this.setState({
            is_export: false,
            is_record: true,
            selected_tab: "details"
        })
        isApiResponse(false);
        if ($.fn.DataTable.isDataTable('#ErrorTableDetails')) {
        $('#ErrorTableDetails').DataTable().clear().destroy();
        $('#ErrorTableDetails thead').empty();
        }

        axios.post(config.get('API_URL') + '/InternalReport/product_error_report_details', {
            months:this.state.months,
            user_type:this.state.errorType
        },
        {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            isApiResponse(true);


        let tableHeadersDetails = [];
        var no_of_rows = response.data.length;
        if(response.data.length>0) {
            const keys = Object.keys(response.data[0]);
            keys.forEach(function (k) {
                //console.log(k)
                 //tableHeadersDetails.push(k);
                 tableHeadersDetails.push({
                        sTitle: k,
                        mData: k.replace(/\./g,'\\.')
                        //optionally do some type detection here for render function
                    });
            });



        this.setState({
            tableHeadersDetails:tableHeadersDetails,
            tableBodyDetails:response.data,

        })
        setTimeout(function(){
            let total = '';
            let pageTotal = '';
            $('#ErrorTableDetails').DataTable( {
                searching: true,
                bInfo : false,
                paging: false,
                "bSort": false,
                "responsive": true,
                "scrollX": false,
                "aoColumns":tableHeadersDetails,
                "aaData": response.data,
//                 "pageLength": 20,
//                 "lengthMenu": [[20, 50, 100, -1], [20, 50, 100, "All"]],


            } );
            MergeGridCells("ErrorTableDetails");
            that.setState({
                loading:false,
                is_export: true,
                isChange: false
            })
        }, 200);
//         setTimeout(function(){
//
//         }, 1000);
        }
        else{
            this.setState({
                is_record: false
            })
        }
    });
    }

    productErrorDownloadCheck(){
        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });
        var postData = {
            months:this.state.months,
            user_type:this.state.errorType
        };
        var that = this;
        var download_url = "";
        var downloaded_file = ""
        if(this.state.selected_tab==='standard') {
            download_url = "/InternalReport/product_error_report_download";
            downloaded_file = "product_error_report.csv.gz";
        }
        if(this.state.selected_tab==='details') {
            download_url = "/InternalReport/nonuser_error_report_download";
            downloaded_file = "productr_error_details_report.csv.gz";
        }
        let xhrBank = $.ajax({
            url: config.get('API_URL') + download_url,
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
//             xhrFields: {
//                 responseType: 'blob'
//             },
            success: function (response, status, xhr) {
                this.copyFile(response.data, downloaded_file);
                this.setState({
                    fetch_data:true
                })
            }.bind(this),
            error: function(data) {
                that.closeModal();
                alert("Failed to download data. Please try again");
            }
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyFile (remotePath, downloaded_file){
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+downloaded_file;
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }

    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });
        this.get_filtered_error_report(yestSend, todSend);
    }
    reset_all(){
        this.setState({
            months:"",
            monthValue:[],
            errorTypeValue:[],
            errorType:"",
        })
        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    change_error_type(optionSelected)
    {
        let value='';
        let errorArray = [];
        if(optionSelected.length < 1){
            value = null;
            errorArray='';
        }
        else{
            optionSelected.map((errorVal, i) => {
                errorArray.push(errorVal.value)
                var index = this.state.errorTypeLists.findIndex(obj => obj.value==errorVal.value);
                this.state.errorTypeLists.move(index,0).join(',');
            });
        }

        this.setState({
            errorType:errorArray,
            errorTypeValue:optionSelected,
            isChange: true
        });
    }
    render() {
        const headersList =this.state.tableHeaders.map((header, i) => {
            return (
                <th width="70" key={i}>{header}</th>
            )
        });
        let TableData = this.state.tableBody.map((data,index) => {
//         if(index===10)
//         {
//             return(
//             <React.Fragment>
//                  <tr>
//                  {this.state.tableHeaders.map((value1, index1) => {
//                     return <td className="no-border" key={index1} >&nbsp;</td>
//                  })}
//                  </tr>
//                  <tr key={index + 1}>
//                 {this.state.tableHeaders.map((value1, index1) => {
//                     return <td key={index1} >{data[value1]}</td>
//                 })}
//                 </tr>
//                 </React.Fragment>
//             )
//         }
            return (

                <tr key={index + 1}>
                {this.state.tableHeaders.map((value1, index1) => {
                    return <td key={index1} >{data[value1]}</td>
                })}
                </tr>
            )

        });

        const headersListDetails =this.state.tableHeadersDetails.map((header, i) => {
            return (
                <th width="70" key={i}>{header}</th>
            )
        });
        let TableDataDetails = this.state.tableBodyDetails.map((data,index) => {

            return (

                <tr key={index + 1}>
                {this.state.tableHeadersDetails.map((value1, index1) => {
                    return <td key={index1} >{data[value1]}</td>
                })}
                </tr>
            )

        });

        return(
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Product Error Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12">
{/*                                             <div className="col-md-2 filter-bottom5 padd-5 date-icon-small"> */}
{/*                                                 <div><label> Date Filter: </label></div> */}
{/*                                                 <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow} */}
{/*                                                 start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/> */}
{/*                                             </div> */}

                                                <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                    <div><label> Month: </label></div>
                                                        <ReactMultiSelectCheckboxes name="month"
                                                            isMulti
                                                            value={this.state.monthValue}
                                                            styles={reactSelectStyles} className="chainLists"
                                                            isClearable={false}
                                                            onChange={this.changeMonth.bind(this)}
                                                            options={this.state.monthsLists}

                                                            placeholderButtonLabel="Select[Months]"
                                                        />
                                                </div>
                                                {this.state.selected_tab==='details'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Error Type</label>
                                                <ReactMultiSelectCheckboxes name="txn_type"
                                                    isMulti
                                                    value={this.state.errorTypeValue}
                                                    styles={reactSelectStyles} className="report-listbox"
                                                    isClearable={false}
                                                    onChange={this.change_error_type.bind(this)}
                                                    options={this.state.errorTypeLists}
                                                    placeholderButtonLabel="Select [Error Type]"
                                                />
                                                <div className="clearfix"></div>
                                            </div>: null}
                                        </div>
                                        <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.apply_filter.bind(this, '','',this.state.selected_tab)}>Apply</button>
                                            &nbsp;&nbsp;<button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>
                                    </div>

                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <Tabs>
                                        <TabList>
                                            <Tab onClick={()=>this.get_filtered_error_report('summary','pilot_summary')}>Product Error Report</Tab>
                                            <Tab onClick={()=>this.get_filtered_error_report_details('details','pilot_details')}>Product Error Report Detail</Tab>
                                        </TabList>
                                         <TabPanel>
                                            {this.state.is_export ?
                                            <div className="">
                                                <a href="#" className="exportButton" role="button" onClick={this.productErrorDownloadCheck.bind(this)}>
                                                    <i className="fa fa-download" aria-hidden="true"></i>
                                                    Export to CSV
                                                </a>
                                            </div>: null }
                                            <div className="clearfix"></div>

                                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                        {this.state.is_record===false?
                                                        <div  className="dataTables_empty">No matching records found</div>
                                                        :
                                                        <table id="ErrorTable" className="table table-striped table-hover">
                                                            <thead>
                                                                <tr>
                                                                {headersList}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {TableData}
                                                            </tbody>
                                                        </table>}

                                                    </div>
                                            </TabPanel>
                                            <TabPanel>
                                                {this.state.is_export ?
                                            <div className="">
                                                <a href="#" className="exportButton" role="button" onClick={this.productErrorDownloadCheck.bind(this)}>
                                                    <i className="fa fa-download" aria-hidden="true"></i>
                                                    Export to CSV
                                                </a>
                                            </div>: null }
                                            <div className="clearfix"></div>

                                                    <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                                        {this.state.is_record===false?
                                                        <div  className="dataTables_empty">No matching records found</div>
                                                        :
                                                        <table id="ErrorTableDetails" className="table table-striped table-hover">
{/*                                                             <thead> */}
{/*                                                                 <tr> */}
{/*                                                                 {headersListDetails} */}
{/*                                                                 </tr> */}
{/*                                                             </thead> */}
{/*                                                             <tbody> */}
{/*                                                                 {TableDataDetails} */}
{/*                                                             </tbody> */}
                                                        </table>
                                                        }
                                                    </div>
                                            </TabPanel>
                                        </Tabs>
                                        </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        {this.state.fetch_data===false?
                                                        <p>Fetching Data & Generating CSV...</p>:<p>Fetching File. Please wait...</p>}
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         
       );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)( ProductErrorReport);